export default "__VITE_ASSET__B8$iUC3P__"